import { Component, ViewChild, forwardRef, OnDestroy, AfterViewInit } from '@angular/core';
import { ManageGridComponent } from '@app/certificates/manage/manage-grid/manage-grid.component';
import { InfoService } from '@app/core/info/info.service';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { IMobileDevice } from '@app/certificates/devices/devices';
import { selectorCertificate } from '@app/certificates/manage/manage.reducer';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ICertificateData } from '@app/certificates/manage/manage';
import { MatExpansionPanel } from '@angular/material/expansion';
import { DevicesGridComponent } from '@app/certificates/devices/devices-grid/devices-grid.component';
import { ManageDevicesEffects } from '@app/certificates/devices/devices.effects';
import { ActionProfilePlanGet } from '@app/profile/profile-remaining-count/profile-plan.actions';

@Component({
  selector: 'cloud-devices-page',
  templateUrl: './devices-page.component.html',
  styleUrls: ['./devices-page.component.scss'],
})
export class DevicesPageComponent implements OnDestroy, AfterViewInit {
  @ViewChild(forwardRef(() => DevicesGridComponent)) devicesGridComponent: DevicesGridComponent;
  @ViewChild(forwardRef(() => MatExpansionPanel)) panel: MatExpansionPanel;
  @ViewChild(forwardRef(() => ManageGridComponent)) manageComponentRef: ManageGridComponent;

  unsubscribe$: Subject<void> = new Subject<void>();
  showCertList = false;
  selectedDevice: IMobileDevice;
  expandList = false;
  private _certificates: ICertificateData[];

  constructor(
    public info: InfoService,
    private translateService: TranslateService,
    private store: Store<any>,
    private deviceEffects: ManageDevicesEffects
  ) {
    this.store
      .select(selectorCertificate)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(certificates => {
        if (certificates instanceof Array) {
          this._certificates = certificates;
        }
      });
    this.store.dispatch(new ActionProfilePlanGet());
  }

  ngAfterViewInit() {
    try {
      // Слушаме за изтрито устройство, за да скрием списъка с удостоверения
      this.deviceEffects.deleteSuccess$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => this.selectedDevice = null);

      this.panel.expandedChange
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(open => {
          (open)
            ? setTimeout(() => { this.showCertList = true; }, 250)
            : this.showCertList = false;
        });
    } catch (error) { }
  }

  onShowCertificates(device: IMobileDevice) {
    const filteredCerts = this._certificates.filter(cert => device.certificateReqIds.indexOf(cert.certReqId) > -1);
    this.info.dismissAll();
    if (filteredCerts instanceof Array && filteredCerts.length > 0) {
      this.showCertList = true;
      this.manageComponentRef.selectedDevice = device;
      this.manageComponentRef.setDataSource(filteredCerts);
      this.selectedDevice = device;
      this.expandList = true;

      if (!this.panel.expanded) {
        this.showCertList = false;
        this.panel.open();
      }
    } else {
      this.info.warning(
        this.translateService.instant(this.devicesGridComponent.resultTexts + 'noCertsForDevice', { deviceName: device.name })
      );
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
